<script lang="ts">
	import { format } from 'svelte-i18n';

	import {
		control_bluetooth_device_ios,
		control_bluetooth_motion_sensitivity_ios,
	} from 'src/services/native_container_requests_ios';
	import {
		control_bluetooth_device_android,
		control_bluetooth_motion_sensitivity_android,
	} from 'src/services/native_container_requests_android';

	import { app, os } from 'src/stores/session/native-bridge';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';

	import { Radio, Button, Text, Stack } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { bindSettingsDrilldownBack, bindStickyBottomAction } from 'src/helpers/sticky_bottom_action';
	import {
		isBleSettingsSessionReady,
		persistBleDeviceSetting,
		readStoredBleDevice,
		resumeBleSettingsConnectionIfNeeded,
	} from 'src/helpers/ble_settings_session';
	import DynamicAlert from './DynamicAlert.svelte';

	export let device;

	const storedDevice = readStoredBleDevice(device);
	let motionSensitivity =
		storedDevice?.motionSensitivity + '' ? storedDevice.motionSensitivity + '' : '0';
	let hadSession = false;

	$: sessionReady = isBleSettingsSessionReady($controlBleDevice.connectionState);
	$: if (sessionReady) hadSession = true;
	$: resumeBleSettingsConnectionIfNeeded(device.id, $controlBleDevice);
	$: controlsDisabled = !sessionReady || !$app;
	let options = [
		{
			translation_key: 'option_low_sensitivity',
			translation_default: 'low sensitivity',
		},
		{
			translation_key: 'option_moderate_sensitivity',
			translation_default: 'moderate sensitivity',
		},
		{
			translation_key: 'option_high_sensitivity',
			translation_default: 'high sensitivity',
		},
	];

	const goBackToSettingsList = bindSettingsDrilldownBack();

	const setMotionSensitivity = () => {
		if ($controlBleDevice.connectionState === 2) {
			$os === 'IOS'
				? control_bluetooth_motion_sensitivity_ios(device.id, motionSensitivity)
				: control_bluetooth_motion_sensitivity_android(device.id, motionSensitivity);

			persistBleDeviceSetting(device, { motionSensitivity });
			goBackToSettingsList?.();
		} else {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};

	const { stickyBottomAction, setStickyBottomAction } = bindStickyBottomAction();

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			setStickyBottomAction({
				onClick: setMotionSensitivity,
				loading: false,
				disabled: controlsDisabled,
				icon: 'fas fa-save',
			});
		} else {
			setStickyBottomAction(null);
		}
	}
</script>

<DynamicAlert showExpiredMsg={hadSession} />

<Text styleType="body-small" class="mb-s">
	{$format('text_motion_sensitivity', {
		default: 'Set the motion sensitivity of the device.',
	})}
</Text>

<Stack gap="s" class="mb-m">
	{#each options as option, index}
		<Radio
			bind:selected={motionSensitivity}
			size="m"
			value={'' + index}
			disabled={controlsDisabled}
			id="radio-motion-sensitivity-{index}"
			>{$format(option.translation_key, {
				default: option.translation_default,
			})}</Radio
		>
	{/each}
</Stack>

{#if !$showNewLayout}
	<Button disabled={controlsDisabled} size="m" width="full" on:click={setMotionSensitivity}>
		{$format('button_save', { default: 'Save' })}
	</Button>
{/if}
